import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import AIQuestionGenerator from '../../../components/QuestionBank/AIQuestionGenerator';
import AIGeneratedQuestionsList from '../../../components/QuestionBank/AIGeneratedQuestionsList';

// Error boundary to prevent crashes from propagating
class AIGenerationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AIGenerationPage error boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="shadow mt-4">
          <CardBody className="text-center py-5">
            <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h3>Something went wrong</h3>
            <p className="text-muted">
              An error occurred while loading this section. Please try refreshing the page.
            </p>
            <Button
              color="primary"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              <i className="fas fa-redo mr-2"></i>
              Try Again
            </Button>
          </CardBody>
        </Card>
      );
    }
    return this.props.children;
  }
}

const AIGenerationPage = ({ userDetails }) => {
  const userEmail = userDetails?.email || '';

  return (
    <>
      {/* Header */}
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <h1 className="text-white mb-0">AI Question Generation</h1>
            <p className="text-white mt-0 mb-0">Use AI to automatically generate questions for the question bank</p>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        <AIGenerationErrorBoundary>
          <Row>
            <Col lg="12">
              <AIQuestionGenerator userEmail={userEmail} />
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <AIGeneratedQuestionsList userEmail={userEmail} />
            </Col>
          </Row>
        </AIGenerationErrorBoundary>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.loginAuth.userDetails
});

export default connect(mapStateToProps)(AIGenerationPage);
